import React from 'react';
import classNames from 'classnames';
import dateUtils from '../../utils/dateUtils';
import './DaySelection.less';

// eslint-disable-next-line complexity
function DaySelection({ariaLabelDate, day, dayTemplate, hoverDate, selectedDate, selectionEnd, selectionStart, simple}) {
    if (!day) {
        return false;
    }

    let isSingleDate = false;
    let isBoundStart = false;
    let isBoundEnd = false;
    let isTween = false;

    const compare = dateUtils.compareDateStrings;

    const dayContent = dayTemplate ||
    <div className="date" aria-hidden="true">
        <p className="hidden">{ariaLabelDate}</p>
        {day.day}
    </div>;

    if (selectedDate && compare(selectedDate, day.dateString) === 0) {
        isSingleDate = true;
    } else if (hoverDate && compare(hoverDate, day.dateString) === 0 && selectionStart && compare(selectionStart, day.dateString) >= 0) {
        isBoundEnd = true;
    } else if (selectionStart && compare(selectionStart, day.dateString) === 0) {
        isBoundStart = true;
    } else if (selectionEnd && compare(selectionEnd, day.dateString) === 0) {
        isBoundEnd = true;
    } else if (selectionStart && selectionEnd && compare(selectionStart, day.dateString) > 0 && compare(selectionEnd, day.dateString) < 0) {
        isTween = true;
    } else if (selectionStart && hoverDate && compare(selectionStart, day.dateString) > 0 && compare(hoverDate, day.dateString) <= 0) {
        isTween = true;
    }

    const isBound = isBoundStart || isBoundEnd || isSingleDate;

    const tweenClasses = classNames({
        'tween': !(isBound && !simple && isSingleDate),
        'start': isBoundStart && simple,
        'end': isBoundEnd && simple,
        'hidden': !hoverDate && !selectionEnd
    });

    if (isBound || isTween) {
        return (
            <div aria-selected="true" className="selection">
                {!isBound &&
                    <div className={tweenClasses}/>
                }

                {isBound &&
                    <div className="bound bg-brand text-white">
                        {dayContent}
                    </div>
                }

                {!isBound && dayContent}
            </div>
        );
    }

    return dayContent;
}

DaySelection.defaultProps = {isSelected: () => {}};

export default DaySelection;
